import Appsignal from "@appsignal/javascript";
import { plugin } from "@appsignal/plugin-path-decorator";

import { ENVIRONMENT, environment } from "@/lib/environment";
import { envVars } from "@/lib/envVars";

const ENVIRONMENT_TO_API_KEY: Record<ENVIRONMENT, string | undefined> = {
  development: envVars.VITE_APPSIGNAL_DEV_API_KEY,
  test: envVars.VITE_APPSIGNAL_TEST_API_KEY,
  staging: envVars.VITE_APPSIGNAL_STAGING_API_KEY,
  production: envVars.VITE_APPSIGNAL_PROD_API_KEY,
};

export const appsignal = new Appsignal({
  key: ENVIRONMENT_TO_API_KEY[environment],
  revision: import.meta.env.VITE_COMMIT_SHA as string | undefined,
});

appsignal.use(plugin());

export default appsignal;
